// extracted by mini-css-extract-plugin
module.exports = {"list":"AuthList_list__dHLko","isModal":"AuthList_isModal__22KuN","link":"AuthList_link__1MyRE","action":"AuthList_action__2IR58"};